import { render } from "./EditValidationCheck.vue?vue&type=template&id=636f6734&ts=true"
import script from "./EditValidationCheck.vue?vue&type=script&lang=ts"
export * from "./EditValidationCheck.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__